import ShiftPatternAddForm from './ShiftPatternAddForm';

export default ShiftPatternAddForm;
